/*
<summary>
  This functional component "ProjectInfoHOC" provides props to the child component.
  1. State "showProjectInfo" that manages the show/hide of pop up
  2. Function "ProjectInfoToggleHandler" to toggle the show/hide popup state "showProjectInfo"
  Developer:Pratiksha Sharma, Created Date:05-May-2026, Last Updated By: Pratiksha Sharma, Updated Date: 05-May-2026
</summary>
<returns>Returns JSX</returns>
*/

import React, { useState } from 'react';

const ProjectInfoHOC = (Component: any) =>
  function Comp(props: any) {
    const [showProjectInfo, setShowProjectInfo] = useState<boolean>(false);

    const projectInformationToggleHandler = () => {
      setShowProjectInfo(!showProjectInfo);
    };

    return (
      <Component
        showProjectInfo={showProjectInfo}
        projectInfoToggleHandler={projectInformationToggleHandler}
        {...props}
      />
    );
  };

export default ProjectInfoHOC;
